import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[fileDragDrop]',
    standalone: true,
})
export class FileDragNDropDirective {
    @Input() disabledDragNDrop = false;
    @Output() private filesChangeEmitter: EventEmitter<File[]> = new EventEmitter();
    constructor() {}
    @HostListener('dragover', ['$event']) public onDragOver(evt: any) {
        if (this.disabledDragNDrop) {
            return;
        }
        evt.preventDefault();
        evt.stopPropagation();
    }
    @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
        if (this.disabledDragNDrop) {
            return;
        }
        evt.preventDefault();
        evt.stopPropagation();
    }
    @HostListener('drop', ['$event']) public onDrop(evt: any) {
        if (this.disabledDragNDrop) {
            return;
        }
        evt.preventDefault();
        evt.stopPropagation();
        const valid_files: Array<File> = evt.dataTransfer.files;
        this.filesChangeEmitter.emit(valid_files);
    }
}
